/**
 * 搜索课程(学习项目)
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import {
    ICourseList,
    LIST_TYPE,
    IAppHistorySearch,
    IAppPopular,
    IAppHistoryCourse,
    IAppLenovoCourse,
} from '@umu/umu-types';

export interface IInput {
    page: number;
    size: number;
    category_id?: string;
    keyword?: string;
    sort: LIST_TYPE;
    eid?: string;
    search_id?: string;
}
export interface IParam {
    page: number;
    size: number;
    eid?: string;
    keyword?: string;
    micro_page_id?: string;
}

// 清除历史数据
export const cleanHistory = () => {
    return fetchData(Api.SEARCH_HISTORY_CLEAN).then((res: IListResponse<ICourseList>) => {
        return res.data;
    });
};
// 获取历史搜索数据
export const searchHistory = (data: IParam) => {
    return fetchData(Api.SEARCH_HISTORY, data, { silent: true })
        .then((res: IListResponse<IAppHistorySearch>) => {
            return res.data;
        })
        .catch((err: any) => {
            console.error('searchHistory error', err);
            return [];
        });
};
// 获取推荐课程
export const searchRecommendCourse = (data: IParam) => {
    return fetchData(Api.SEARCH_RECOMMEND_COURSE, data, { silent: true }).then((res: IListResponse<IAppPopular>) => {
        return res.data;
    });
};
// 获取热搜课程
export const searchHotCourse = (data: IParam) => {
    return fetchData(Api.SEARCH_HOT_COURSE, data, { silent: true }).then((res: IListResponse<IAppPopular>) => {
        return res.data;
    });
};
// 获取最近在学课程
export const searchHistoryCourse = (data: IParam) => {
    return fetchData(Api.SEARCH_HISTORY_COURSE, data, { silent: true }).then(
        (res: IListResponse<IAppHistoryCourse>) => {
            return res.data;
        },
    );
};
// 获取联想搜索词
export const searchAssociativeWordsCourse = (data: IParam) => {
    return fetchData(Api.SEARCH_ASSOCIATIVE_COURSE, data, { silent: true }).then(
        (res: IListResponse<IAppLenovoCourse>) => {
            return res.data;
        },
    );
};
